const DropdownUp = (props) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M14.5 10.5L8 4L1.5 10.5H14.5Z' fill='#333333' />
  </svg>
);

export default DropdownUp;
